import React, { useEffect, useState } from 'react';
// import { useHistory } from 'react-router';
// import getData from '../../utils/getData';

import { VscSettingsGear } from 'react-icons/vsc';
import { toast } from 'react-toastify';
import api from 'src/service/api';
import Loader from '../../components/Loader';
import {
    Container,
    GearIconContainer,
    SpinnerIcon,
    SyncButton
} from './styles';

const Parametros: React.FC = () => {
    const [showContent, setShowContent] = useState(false);
    const [sincronizandoSetores, setSincronizandoSetores] = useState(false);
    const [sincronizandoAfastamentos, setSincronizandoAfastamentos] = useState(false);
    const [sincronizandoAniversariantes, setSincronizandoAniversariantes] = useState(false);
    const [sincronizandoColaboradores, setSincronizandoColaboradores] = useState(false);
    const [sincronizandoUsuarios, setSincronizandoUsuarios] = useState(false);
    const [sincronizandoLotacoes, setSincronizandoLotacoes] = useState(false);
    const [sincronizandoFGs, setSincronizandoFGs] = useState(false);
    // const [params, setParams] = useState([]);
    // const [modalIsOpen, setModalIsOpen] = useState(false);
    // const history = useHistory();


    const executaSincronia = async (
        tabela: string,
        url: string
    ): Promise<void> => {
        try {
            if (tabela === 'afastamento') {
                setSincronizandoAfastamentos(true);
            }
            if (tabela === 'aniversariante') {
                setSincronizandoAniversariantes(true);
            }
            if (tabela === 'colaborador') {
                setSincronizandoColaboradores(true);
            }
            if (tabela === 'setor') {
                setSincronizandoSetores(true);
            }
            if (tabela === 'usuario') {
                setSincronizandoUsuarios(true);
            }
            if (tabela === 'lotacao') {
                setSincronizandoLotacoes(true);
            }
            if (tabela === 'fg') {
                setSincronizandoFGs(true);
            }
            if (tabela === 'usuario') {
                setSincronizandoUsuarios(true);
            }

            const token = sessionStorage.getItem('token');

            api.defaults.headers.Authorization = `Bearer ${token}`;
            api.defaults.headers.chaValor = process.env.REACT_APP_CHAVE_API;

            const response = await api.post(url);

            if (response.status === 200) {
                toast.success(
                    `Tabela ${tabela} sincronizada com sucesso`
                );
            }
        } catch (err: any) {
            console.log(err.response?.data?.error);

            if (err.response?.data?.error) {
                toast.error(err.response.data.error);
            }
        } finally {
            if (tabela === 'afastamento') {
                setSincronizandoAfastamentos(false);
            }
            if (tabela === 'aniversariante') {
                setSincronizandoAniversariantes(false);
            }
            if (tabela === 'colaborador') {
                setSincronizandoColaboradores(false);
            }
            if (tabela === 'setor') {
                setSincronizandoSetores(false);
            }
            if (tabela === 'usuario') {
                setSincronizandoUsuarios(false);
            }
            if (tabela === 'lotacao') {
                setSincronizandoLotacoes(false);
            }
            if (tabela === 'fg') {
                setSincronizandoFGs(false);
            }
        }
    };

    useEffect(() => {
        setShowContent(true);
    }, []);

    /*
    useEffect(() => {
        getData<IParametro[]>(
            '/parametros',
            (data: IParametro[]) => {
                const trimedData = data.map((parametro) => ({
                    ...parametro,
                    parConsultaSetor: parametro.parConsultaSetor.trim(),
                    parConsultaFG: parametro.parConsultaFG.trim(),
                    parConsultaFiscal: parametro.parConsultaFiscal.trim(),
                    parConsultaLotacao: parametro.parConsultaLotacao.trim(),
                    parConsultaUsuario: parametro.parConsultaUsuario.trim(),
                    parConsultaColaborador: parametro.parConsultaColaborador.trim(),
                    parConsultaAniversariante: parametro.parConsultaAniversariante.trim(),
                    parConsultaAfastamento: parametro.parConsultaAfastamento.trim(),
                }));
                setParams(trimedData);
            },
            history
        ).then(() => setShowContent(true));
    }, [history]);
    */

    if (showContent) {
        return (
            <Container>
                <SyncButton
                    type="button"
                    disabled={sincronizandoAfastamentos}
                    onClick={() =>
                        executaSincronia(
                            'afastamento',
                            'afastamentos/sincroniza'
                        )
                    }
                >
                    <GearIconContainer>
                        <VscSettingsGear size={20} />
                    </GearIconContainer>

                    Sincronizar afastamentos

                    {sincronizandoAfastamentos && <SpinnerIcon size={16} />}
                </SyncButton>
                <SyncButton
                    type="button"
                    disabled={sincronizandoAniversariantes}
                    onClick={() =>
                        executaSincronia(
                            'aniversariante',
                            'aniversariantes/sincroniza'
                        )
                    }
                >
                    <GearIconContainer>
                        <VscSettingsGear size={20} />
                    </GearIconContainer>

                    Sincronizar aniversariantes

                    {sincronizandoAniversariantes && <SpinnerIcon size={16} />}
                </SyncButton>
                <SyncButton
                    type="button"
                    disabled={sincronizandoColaboradores}
                    onClick={() =>
                        executaSincronia(
                            'colaborador',
                            'colaboradores/sincroniza'
                        )
                    }
                >
                    <GearIconContainer>
                        <VscSettingsGear size={20} />
                    </GearIconContainer>

                    Sincronizar colaboradores

                    {sincronizandoColaboradores && <SpinnerIcon size={16} />}
                </SyncButton>
                <SyncButton
                    type="button"
                    disabled={sincronizandoSetores}
                    onClick={() =>
                        executaSincronia(
                            'setor',
                            'setores/sincroniza'
                        )
                    }
                >
                    <GearIconContainer>
                        <VscSettingsGear size={20} />
                    </GearIconContainer>

                    Sincronizar setores

                    {sincronizandoSetores && <SpinnerIcon size={16} />}
                </SyncButton>
                <SyncButton type="button" disabled={sincronizandoFGs} onClick={() =>
                        executaSincronia(
                            'fg',
                            'fgs/sincroniza'
                        )
                    }>
                    <GearIconContainer>
                        <VscSettingsGear size={20} />
                    </GearIconContainer>
                    Sincronizar FG´s

                    {sincronizandoFGs && <SpinnerIcon size={16} />}
                </SyncButton>
                <SyncButton
                    type="button"
                    disabled={sincronizandoLotacoes}
                    onClick={() =>
                        executaSincronia(
                            'lotacao',
                            'lotacoes/sincroniza'
                        )
                    }
                >
                    <GearIconContainer>
                        <VscSettingsGear size={20} />
                    </GearIconContainer>

                    Sincronizar lotações

                    {sincronizandoLotacoes && <SpinnerIcon size={16} />}
                </SyncButton>
                <SyncButton
                    type="button"
                    disabled={sincronizandoUsuarios}
                    onClick={() =>
                        executaSincronia(
                            'usuario',
                            'usuarios/sincroniza'
                        )
                    }
                >
                    <GearIconContainer>
                        <VscSettingsGear size={20} />
                    </GearIconContainer>

                    Sincronizar usuários

                    {sincronizandoUsuarios && <SpinnerIcon size={16} />}
                </SyncButton>
            </Container>
        );
    }
    return <Loader />;
};

export default Parametros;
